import React from 'react'

export default function TeacherAddsection() {
  return (
    <div>
        TeacherAddsection
    </div>
  )
}
